import { Grid, Paper, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import ChartAge from "./age.js";
import ChartGender from "./gender";
import { styles } from "./styles";
import { chartGenderCustomer, chartAgeCustomer } from "../../../utils/setting";

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      data: [],
      listCustomer: [],
    };
    this.genderArray = chartGenderCustomer;
    this.ageArray = chartAgeCustomer;
  }

  render() {
    const { classes, chart = {}, t } = this.props;
    let { gender = [], age = [], other = 0 } = chart;
    const genderChart = Object.keys(this.genderArray).map((element, index) => {
      let data = this.genderArray[element];
      let find = gender.find((e) => e && e._id === element);
      if (!find) find = gender.find((e) => e && !e._id);
      if (find) data.value = find.count;
      return data;
    });

    const ageChart = Object.keys(this.ageArray).map((ele, index) => {
      let data = this.ageArray[ele];
      if (ele !== "other") {
        let find = age.find(
          (e) =>
            e &&
            e.query &&
            e.query.from === data.key[0] &&
            e.query.to === data.key[1]
        );
        if (find) data.value = find.count;
      } else {
        data.value = other;
      }

      return data;
    });
    return (
      <Grid container spacing={4}>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classNames(classes.paperLeft, classes.paper)}>
            <Grid container alignItems={"center"}>
              <Grid item xs={6} sm={4} md={4} className={classes.labelChart}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.titleChart}
                >
                  {t("customer_chart_gender")}
                </Typography>
                {Object.values(this.genderArray).map((item, index) => {
                  if (item.class === "male") {
                    return (
                      <div className={classes.row_info} key={index}>
                        <div
                          className={classNames(classes.square)}
                          style={{ backgroundColor: item.color }}
                        ></div>
                        <span className={classes.text}>{t("male")}</span>
                      </div>
                    );
                  } else if (item.class === "female") {
                    return (
                      <div className={classes.row_info} key={index}>
                        <div
                          className={classNames(classes.square)}
                          style={{ backgroundColor: item.color }}
                        ></div>
                        <span className={classes.text}>{t("female")}</span>
                      </div>
                    );
                  } else {
                    return (
                      <div className={classes.row_info} key={index}>
                        <div
                          className={classNames(classes.square)}
                          style={{ backgroundColor: item.color }}
                        ></div>
                        <span className={classes.text}>{t("other")}</span>
                      </div>
                    );
                  }
                })}
              </Grid>
              <Grid item xs={6} sm={8} md={8}>
                <ChartGender data={genderChart} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classNames(classes.paperRight, classes.paper)}>
            <Grid container alignItems={"center"}>
              <Grid item xs={6} sm={4} md={4} className={classes.labelChart}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.titleChart}
                >
                  {t("customer_chart_age")}
                </Typography>
                {Object.values(this.ageArray).map((item, index) => {
                  return (
                    <div className={classes.row_info} key={index}>
                      <div
                        className={classNames(classes.square)}
                        style={{ backgroundColor: item.color }}
                      ></div>
                      <span className={classes.text}>
                        {item.key !== "other"
                          ? item.name + " " + t("age")
                          : t(item.name)}
                      </span>
                    </div>
                  );
                })}
              </Grid>
              <Grid item xs={6} sm={8} md={8}>
                <ChartAge data={ageChart} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};
EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  chart: state.customer.chart,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(EnhancedTable)
  )
);
